import { Injectable } from '@angular/core';
import { WebSocketSubject } from 'rxjs/webSocket';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments';
import { IWebsocketMessage } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private socket$?: WebSocketSubject<IWebsocketMessage>;
  public messagesSubject = new BehaviorSubject<IWebsocketMessage>({} as IWebsocketMessage);

  connect(): void {
    this.socket$ = new WebSocketSubject(environment.webSocketUrl);
    // console.log('Connected Websocket');
    this.socket$?.subscribe({
      next: (message: IWebsocketMessage) => {
        // console.log('Received:', message);
        this.messagesSubject.next(message);
      },
      error: (error) => {
        console.error('WebSocket Error:', error)
      },
      complete: () => {
        // console.log('Disconnected Websocket');
      },
    });
  }

  sendMessage(socket_message: IWebsocketMessage): void {
    this.socket$?.next(socket_message);
  }

  close(): void {
    this.socket$?.complete();
  }
}
